import React, {ReactNode} from 'react';
import {SnackbarProvider, SnackbarProviderProps, useSnackbar} from 'notistack';
import {Box, IconButton, Slide} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {SaltusAny} from '../../utils/SaltusAny';

const classes = {
  contentRoot: {
    alignItems: 'flex-start',
    position: 'relative',
    '& svg': {
      color: 'white',
    },
  },
};

// props beyond children are spread onto SnackbarProvider, e.g. anchorOrigin
interface NotificationsProviderProps extends Partial<SnackbarProviderProps> {
  children: ReactNode;
}

type Key = string | number | undefined;

interface CloseSnackbarProps {
  snackbarKey: Key;
}

const CloseButton: React.FC<CloseSnackbarProps> = ({snackbarKey}) => {
  const {closeSnackbar} = useSnackbar();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignContent="flex-start"
      justifyContent="flex-start"
    >
      <IconButton
        aria-label="Close this notification"
        color="inherit"
        onClick={() => closeSnackbar(snackbarKey)}
        size="large"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

function NotificationsProvider(props: NotificationsProviderProps) {
  const {children} = props;

  return (
    <SnackbarProvider
      action={(key) => <CloseButton snackbarKey={key} />}
      classes={classes as SaltusAny}
      TransitionComponent={Slide}
      style={{transform: `scale(1.5)`}}
      {...props}
    >
      {children}
    </SnackbarProvider>
  );
}

export default NotificationsProvider;
